export default "# Hello\n\n::demo{name=rich_text}\n\n# ProseMirror\n\n::demo{name=prose_mirror}"